var _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFacebookNotConnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.625 16.0772C28.625 9.06194 22.9446 3.375 15.9375 3.375C8.93038 3.375 3.25 9.06194 3.25 16.0772C3.25 22.4172 7.88963 27.6721 13.9551 28.625V19.7489H10.7337V16.0772H13.9551V13.2787C13.9551 10.0952 15.8492 8.33679 18.7473 8.33679C20.1355 8.33679 21.5874 8.58487 21.5874 8.58487V11.7108H19.9875C18.4114 11.7108 17.9199 12.6899 17.9199 13.6944V16.0772H21.4387L20.8762 19.7489H17.9199V28.625C23.9854 27.6721 28.625 22.4172 28.625 16.0772",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7956 19.6796L21.3527 16.0425H17.8676V13.6822C17.8676 12.6871 18.3544 11.7172 19.9154 11.7172H21.5V8.62075C21.5 8.62075 20.0619 8.375 18.6871 8.375C15.8167 8.375 13.9406 10.1169 13.9406 13.2704V16.0425H10.75V19.6796H13.9406V28.4721C14.5902 28.5741 15.2466 28.6252 15.9041 28.625C16.5721 28.625 17.2278 28.5727 17.8676 28.4721V19.6796H20.7956Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 6,
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30C22.2385 30 20 27.7615 20 25C20 22.2385 22.2385 20 25 20C27.7615 20 30 22.2385 30 25C30 27.7615 27.7615 30 25 30ZM25 24.293L23.586 22.8785L22.8785 23.586L24.293 25L22.8785 26.414L23.586 27.1215L25 25.707L26.414 27.1215L27.1215 26.414L25.707 25L27.1215 23.586L26.414 22.8785L25 24.293Z",
    fill: "#FF6633"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFacebookNotConnected);
export default __webpack_public_path__ + "static/media/logo_facebook_not_connected.afb547926edc44a523a1e9b1b8c5defe.svg";
export { ForwardRef as ReactComponent };